import aa from "search-insights";
import type { AlgoliaEventMethods } from "@lib/analytics/analyticsTypes";

type RecommendInsightsParams = {
    objectIDs: string[];
    eventName: string;
    index: string;
    [key: string]: unknown;
};

export function sendRecommendInsightsEvent(
    method: AlgoliaEventMethods,
    params: RecommendInsightsParams
): void {
    const objectIDs = params.objectIDs.filter((id): id is string => Boolean(id));
    if (objectIDs.length === 0) {
        return;
    }
    aa(method, { ...params, objectIDs });
}
